import { Menu, token } from "@may-i/mash-design-system";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import type { FloorPlan } from "~/_legacy/types/analysis";

interface Props {
  floorPlans: FloorPlan[];
  selectedFloorPlanId: number | null;
  onChange: (floorPlanId: number) => void;
  loading?: boolean;
}

export function AddAdjustGuideFloorPlanSelect({ floorPlans, selectedFloorPlanId, onChange, loading }: Props) {
  const { t } = useTranslation("shared");

  const current = floorPlans.find((fp) => fp.id === selectedFloorPlanId);
  const disabled = !loading && floorPlans.length === 0;

  return (
    <Menu.Root
      value={selectedFloorPlanId?.toString() ?? ""}
      onValueChange={(value) => {
        const parsed = parseInt(value);
        if (!isNaN(parsed)) onChange(parsed);
      }}
    >
      <StyledTrigger
        size="xSmall"
        placeholder={t("addAdjustGuideModal.addAdjustGuideFloorPlanSelect.placeholder")}
        disabled={disabled}
      >
        {current?.name}
      </StyledTrigger>
      <StyledItems avoidCollisions>
        {floorPlans.map((fp) => (
          <Menu.Item key={fp.id} value={fp.id.toString()} size="small">
            {fp.name}
          </Menu.Item>
        ))}
      </StyledItems>
    </Menu.Root>
  );
}

const StyledTrigger = styled(Menu.Trigger)`
  --radix-select-trigger-width: 200px;
  width: var(--radix-select-trigger-width);
  cursor: pointer;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
`;

const StyledItems = styled(Menu.Items)`
  width: fit-content;
  min-width: var(--radix-select-trigger-width);
  max-height: 240px;
  z-index: 1000;

  [data-highlighted] {
    background: ${token("colors.action.hover")};
  }
`;
